import {
  TimerActionTypes,
  StartTimerAction,
  PauseTimerAction,
  ResumeTimerAction,
  StopTimerAction,
  ResetTimerAction,
  RestartTimerAction,
  AddTimeAction,
  ToggleModeAction,
  SetVisibilityAction,
} from './types'

export const startTimer = (sessionId: string, duration: number): StartTimerAction => ({
  type: TimerActionTypes.START_TIMER,
  payload: { sessionId, duration },
})

export const pauseTimer = (): PauseTimerAction => ({
  type: TimerActionTypes.PAUSE_TIMER,
})

export const resumeTimer = (): ResumeTimerAction => ({
  type: TimerActionTypes.RESUME_TIMER,
})

export const stopTimer = (): StopTimerAction => ({
  type: TimerActionTypes.STOP_TIMER,
})

export const resetTimer = (): ResetTimerAction => ({
  type: TimerActionTypes.RESET_TIMER,
})

export const restartTimer = (): RestartTimerAction => ({
  type: TimerActionTypes.RESTART_TIMER,
})

export const addTime = (seconds: number): AddTimeAction => ({
  type: TimerActionTypes.ADD_TIME,
  payload: seconds,
})

export const toggleMode = (): ToggleModeAction => ({
  type: TimerActionTypes.TOGGLE_MODE,
})

export const setVisibility = (visible: boolean): SetVisibilityAction => ({
  type: TimerActionTypes.SET_VISIBILITY,
  payload: visible,
})
